module.exports = __webpack_public_path__ + "static/media/starEmpty.179f660e.svg";